import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios' // remove comment if yu needed
import app from '../../main' // import the instance
import Crud from '../crud'
import checkResponse from '@/utils/checkResponse'
const model = (payload) => ({
  // columns
  id: payload.id
})
var crud = new Crud('ProjectContacts', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  projectContacts: [],
  catalog: {
    employees: []
  },
  isModalContactVisible: false
}

const mutations = {
  ...crud.mutations,
  SET_MODAL_CONTACT_VISIBLE (state, payload) {
    state.isModalContactVisible = payload
  }
}

const actions = {
  ...crud.actions,
  setModalContactVisible ({ commit }, payload) {
    commit('SET_MODAL_CONTACT_VISIBLE', payload)
  },
  loadToQuotes ({ commit, dispatch, getters }, payload) {
    dispatch('ToQuotes/loadToQuotes', { page: payload.page, customer: payload.customer }, { root: true })
  },
  loadQuotes ({ commit, dispatch, getters }, payload) {
    dispatch('Quotes/loadQuotes', { page: payload.page, customer: payload.customer }, { root: true })
  },
  loadQuoting ({ commit, dispatch, getters }, payload) {
    dispatch('Quotes/loadQuoting', { page: payload.page, customer: payload.customer }, { root: true })
  },
  loadInOrders ({ commit, dispatch, getters }, payload) {
    dispatch('InOrders/loadInOrders', { page: payload.page }, { root: true })
  },
  loadFinisheds ({ commit, dispatch, getters }, payload) {
    dispatch('Finisheds/loadFinisheds', { page: payload.page }, { root: true })
  },
  async saveContacts ({ commit }, payload) {
    app.$Progress.start()

    try {
      const response = await axios.post(`projects/${payload.id}/select-contacts`, payload)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_MODAL_CONTACT_VISIBLE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.projects', text: 'front.added_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  }
}

const getters = {
  ...crud.getters,
  projectContacts: state => state.projectContacts,
  isModalContactVisible: state => state.isModalContactVisible,
  employees: (state, getters, rootState, rootGetters) => rootGetters['ToQuotes/employees']
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
